import { useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 3 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";

// EditProduct project components
import ProductImage from "./components/ProductImage";
import Price from "./components/Price";
import MainInfo from "./components/MainInfo";
import LangForm from "./components/LangForm";

import crudsService from "services/cruds-service";
import { useParams } from "react-router-dom";
import i18n from "i18n";
import prepareNewArr from "helper/prepareNewArr";
import deepDiff from "helper/deep-diff";
import getEmptyFields from "helper/getEmptyFields";
import { icon } from "@fortawesome/fontawesome-svg-core";
import { it } from "date-fns/locale";
import MDAlert from "components/MDAlert";

function EditProject() {
  const { t } = i18n;
  const baseUrl = process.env.REACT_APP_API_URL;

  const { id } = useParams();
  const [donationDefaultValues, setDonationDefaultValues] = useState([]);
  const [project, setProject] = useState({
    id: null,
    category: null,
    cost: "",
    status: null,
    zakaat_available: false,
    urgent: false,
    all_amount_required: true,
    categories: [],
    sequence: 0,
    name: "",
    summary: "",
    desc: "",
    promo_video_url: "",
    targets: "",
    timeline: "",
    report_file: null,
    translations: {},
    donation_begin_from: 0,
    date_begin: null,
    date_end: null,
    donation_default_values: "10__50__100",
  });
  const [info, setInfo] = useState({
    id: null,
    category: {},
    cost: "",
    status: {},
    zakaat_available: false,
    urgent: false,
    all_amount_required: true,
    categories: [],
    lisence: "",
    sequence: 0,
    name: "",
    summary: "",
    desc: "",
    translations: {},
  });
  const [linfo, setLInfo] = useState({
    translations: {},
  });
  const [categories, setCategories] = useState([]);

  const [notification, setNotification] = useState({
    value: false,
    color: "info",
    message: "",
  });

  const [errors, setErrors] = useState({
    cost: false,
    benficial_num: false,
    period: false,
    lisence: false,
    sequence: false,
    impl_country_id: false,
    status_id: false,
    period_type: false,
    target_segments: false,
    categories: false,
    faqs: false,
    web_pic: false,
    translations: {
      name: false,
      summary: false,
      desc: false,
    },
  });

  const chkErrors = {
    icon_name: false,
    cost: false,
    categories: false,
    translations: {
      name: false,
      summary: false,
      desc: false,
    },
  };

  const many2manyPrepareNewArr = (arr, name, objKey) => {
    let newArr = [];
    for (const key in arr) {
      if (Object.hasOwnProperty.call(arr, key)) {
        const element = arr[key][name];
        newArr.push({
          id: element?.id,
          name: element?.translations[0][objKey || "name"],
        });
      }
    }
    return newArr;
  };

  const getProjects = async () => {
    // const response = await crudsService.getProjectById(id);
    const response = await crudsService.getAllData(
      `items/projects/${id}?fields=*,translations.report_file,translations.timeline,translations.name,translations.summary,translations.desc,translations.promo_video_url,translations.targets,translations.languages_code.name,translations.languages_code.code,target_segments.id,target_segments.target_segment_id.id,target_segments.target_segment_id.translations.*,impl_country_id.translations.name,impl_country_id.id,status_id.id,status_id.translations.name,status_id.color,categories.categories_id.id,categories.categories_id.translations.*,tags.id,tags.tags_id.id,tags.tags_id.translations.*,faqs.id,faqs.faq_id.id,faqs.faq_id.translations.*`,
    );

    let categoriesArr = [];

    many2manyPrepareNewArr(response.data.categories, "categories_id").forEach(
      (categoryItem) => {
        categoriesArr.push(categoryItem);
      },
    );

    setProject((prevProject) => ({
      ...prevProject,
      translations: response.data.translations.reduce((acc, translation) => {
        acc[translation.languages_code.code] = { ...translation };
        return acc;
      }, {}),
      id: response.data.id,
      name: response.data.translations[0]?.name,
      summary: response.data.translations[0]?.summary,
      desc: response.data.translations[0]?.desc,
      cost: response.data.cost,
      benficial_num: response.data.benficial_num,
      lisence: response.data.lisence,
      zakaat_available: response.data.zakaat_available,
      urgent: response.data.urgent,
      all_amount_required: response.data.all_amount_required,
      categories: categoriesArr,
      sequence: response.data.sequence,
      icon_name: response.data.icon_name,
    }));
  };

  //if id change (when click edit from projects page) get the project data
  useEffect(() => {
    if (!id) return;
    getProjects();
  }, [id]);

  useEffect(() => {
    (async () => {
      try {
        const categoryData = await crudsService.getAllData(
          `items/categories?fields=id,translations.name,parent_id.id,parent_id.translations.name,projects.id,children.id`,
        );
        setCategories(prepareNewArr(categoryData.data));
      } catch (err) {
        console.error(err);
        return null;
      }
    })();
  }, []);

  useEffect(() => {
    if (!project) return;

    let arr = project.donation_default_values?.split("__");
    let newArr = [];
    project.donation_default_values?.length > 0 &&
      arr.forEach((element) => {
        newArr.push({ key: element });
      });
    setDonationDefaultValues(newArr);
    setInfo({
      icon_name: project?.icon_name,
      cost: project?.cost,
      benficial_num: project?.benficial_num,
      lisence: project?.lisence,
      sequence: project?.sequence,
      zakaat_available: project?.zakaat_available,
      urgent: project?.urgent,
      all_amount_required: project?.all_amount_required,
      categories: project?.categories,
    });
  }, [project]);

  const changeHandler = (e, lang) => {
    if (lang) {
      setLInfo({
        translations: {
          ...linfo.translations,
          [lang]: {
            ...linfo.translations[lang],
            [e.target.name]: e.target.value,
            languages_code: lang,
          },
        },
      });
    } else {
      setInfo({
        ...info,
        [e.target.name]: e.target.value,
      });
    }
  };

  const autoSwitchChangeHandler = (name, v) => {
    setInfo({
      ...info,
      [name]: v,
    });
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      const { translations, ...err } = chkErrors;

      let obj = {
        ...getEmptyFields(info, "", err),
        ...getEmptyFields(linfo.translations["ar-SA"], "ar-SA", translations),
        ...getEmptyFields(
          linfo.translations["en-US"] || {
            name: "",
            summary: "",
            desc: "",
          },
          "en-US",
          translations,
        ),
        ...getEmptyFields(
          linfo.translations["tr-TR"] || {
            name: "",
            summary: "",
            desc: "",
          },
          "tr-TR",
          translations,
        ),
      };

      const hasErrors = Object.values(obj).some((v) => v === true);

      if (hasErrors) {
        setErrors(obj);
        return; // stop
      }

      const trns = Object.values(linfo.translations);

      if (id) {
        await crudsService.updateItem(`items/projects/${id}`, {
          icon_name: info?.icon_name,
          cost: info?.cost,
          sequence: info?.sequence,
          all_amount_required: 1,
          translations: trns,
        });
      } else {
        await crudsService.createItem(`items/projects`, {
          icon_name: info?.icon_name,
          cost: info?.cost,
          sequence: info?.sequence,
          all_amount_required: true,
          categories: info?.categories.map((cat) => ({
            categories_id: cat.id,
          })),
          translations: trns,
        });
      }
      setNotification({
        value: true,
        color: "success",
        text: "تم الحفظ بنجاح",
      });

      // console.log(diff);
    } catch (err) {
      console.error(err);
      setNotification({
        value: true,
        color: "error",
        text: "حدث خطأ ما، الرجاء المحاولة مرة أخرى",
      });
    }
  };

  return (
    <DashboardLayout>
      <MDBox my={3}>
        <MDBox mb={6}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} lg={6}>
              <MDTypography variant="h4" fontWeight="medium">
                {!id ? "صفحة المشروع" : project.name}
              </MDTypography>
            </Grid>
            <Grid item xs={12} lg={6}>
              <MDBox display="flex" justifyContent="flex-end">
                <MDButton
                  variant="gradient"
                  color="info"
                  onClick={submitHandler}
                >
                  {t("save")}
                </MDButton>
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
        {notification.value === true && (
          <MDAlert color={notification.color} mt="20px">
            <MDTypography variant="body2" color="white">
              {notification.text}
            </MDTypography>
          </MDAlert>
        )}
        <Grid container spacing={3}>
          <Grid item xs={12} lg={3}>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={12}>
                <Price
                  project={project}
                  autoSwitchChangeHandler={autoSwitchChangeHandler}
                  categories={categories}
                  changeHandler={changeHandler}
                  setInfo={setInfo}
                  info={info}
                  setErrors={setErrors}
                  errors={errors}
                  notification={notification}
                  setNotification={setNotification}
                  donationDefaultValues={donationDefaultValues}
                  setProject={setProject}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} lg={9}>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={12}>
                <LangForm
                  project={project}
                  changeHandler={changeHandler}
                  setInfo={setLInfo}
                  info={linfo}
                  notification={notification}
                  setNotification={setNotification}
                  errors={errors}
                  setErrors={setErrors}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default EditProject;
